import PropTypes from 'prop-types'
import { Button, ButtonGroup, Menu, MenuItem } from '@mui/material'

import { ReactComponent as CaretDown } from '../../../assets/icons/caret-down.svg'

import { useRef, useState, useEffect } from 'react'

import styles from './styles'

const SplitButton = ({ size = 'small', options = [] }) => {
  const [open, setOpen] = useState(false)
  const anchorRef = useRef(null)
  const [selectedIndex, setSelectedIndex] = useState(0)

  useEffect(() => {
    if (options.length > 0 && selectedIndex >= options.length) {
      setSelectedIndex(0)
    }
  }, [options, selectedIndex])

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index)
    setOpen(false)
    options[index].onClick(event)
  }

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen)
  }

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }

    setOpen(false)
  }

  return (
    <>
      {options.length > 0 && (
        <>
          <ButtonGroup size={size} ref={anchorRef} aria-label="split button">
            <Button onClick={options[selectedIndex]?.onClick}>
              {options[selectedIndex]?.text}
              {options[selectedIndex]?.count > 0 && (
                <span style={styles.buttonChip}>
                  {options[selectedIndex].count}
                </span>
              )}
            </Button>
            {options.length > 1 && (
              <Button
                aria-controls={open ? 'split-button-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-label="select merge strategy"
                aria-haspopup="menu"
                onClick={handleToggle}
              >
                <CaretDown width={20} height={20} />
              </Button>
            )}
          </ButtonGroup>
          {options.length > 1 && (
            <Menu
              anchorEl={anchorRef.current}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                sx: {
                  width: anchorRef ? anchorRef.current?.offsetWidth : null,
                },
              }}
            >
              {options.map((option, index) => (
                <MenuItem
                  key={option.text}
                  selected={index === selectedIndex}
                  onClick={event => handleMenuItemClick(event, index)}
                >
                  {option.text}
                </MenuItem>
              ))}
            </Menu>
          )}
        </>
      )}
    </>
  )
}

SplitButton.propTypes = {
  size: PropTypes.string,
  options: PropTypes.array,
}

export default SplitButton
